import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { LabsComponent } from '@app/components/apps/Labs&Research/LabComponent';

const breadcrumbMap: Record<string, { path: string; name: string }> = {
  REGULAR_TEST: { path: '/lab-regular-tests', name: 'Labs & Research - Regular Tests' },
  AQO_INITIATED: { path: '/lab-aqo-initiated', name: 'Labs & Research - AQO Initiated' },
  BI_ANNUAL: { path: '/lab-bi-annual-tests', name: 'Labs & Research - Bi Annual Tests' },
  DIRECT_SALES: { path: '/lab-direct-sales', name: 'Labs & Research - Direct Sales' },
  VACCINE_MANUFACTURING: { path: '/lab-vaccine-manufacture', name: 'Labs & Research - Vaccine Manufacture' },
  DISEASE_SURVEILLANCE: { path: '/lab-disease-surveillance', name: 'Labs & Research - Disease Surveillance' },
};

export const CreateLabTask: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Create Lab Task');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const labType = localStorage.getItem('selected_lab_type') || 'REGULAR_TEST';
  const categoryData = breadcrumbMap[labType] || { path: '/lab-tasks', name: 'Labs & Research' };

  const routes = [
    { path: categoryData.path, breadcrumbName: categoryData.name },
    { path: '/add-lab-task', breadcrumbName: currentBreadcrumName },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName, labType]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <LabsComponent
          type={'create'}
          editable={false}
          id={id}
          pageTitle={`Create Lab Task`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default CreateLabTask;
